import { CarConfigurationServiceV2 } from '@volkswagen-onehub/car-configuration-feature-service';
import { FeatureappServiceOptions } from '@volkswagen-onehub/featureapp-service';

interface EnvironmentData {
	apiKey?: string;
	mofaFeatureAppName?: string;
}

interface InternalFeatureAppDefinitions {
	featureApps: FeatureappServiceOptions;
}

export type ApplicationConfig = EnvironmentData & InternalFeatureAppDefinitions;

// @TODO remove this completely
class Environment {
	public carConfigurationService: CarConfigurationServiceV2 | null = null;
	private environmentData: EnvironmentData = {
		apiKey: undefined,
		mofaFeatureAppName: undefined
	};

	get apiKey(): undefined | string {
		return this.environmentData.apiKey;
	}

	public updateEnvironment(environment: EnvironmentData) {
		this.environmentData = {
			...this.environmentData,
			...environment
		};
	}
}

export default new Environment();
